import React from 'react'
import {
  InputField,
  UploadImageField
} from 'components/molecules'
import { Button, Card } from 'reactstrap'
import { DESCRIPTION } from 'domains/cms-blog-post/constants'
import ProductCollectionAsyncMultiselectField from 'domains/product-collection/molecules/async-multiselect-field'
import { FieldArray } from 'formik'
import PropTypes from 'prop-types'

const propTypes = {
  formikBag           : PropTypes.object,
  sectionImages       : PropTypes.array,
  setSectionImages    : PropTypes.func,
  tempSectionImage    : PropTypes.array,
  setTempSectionImage : PropTypes.func,
  sectionInitialValue : PropTypes.object
}

const defaultProps = {
  formikBag           : {},
  sectionImages       : [],
  setSectionImages    : () => {},
  tempSectionImage    : [],
  setTempSectionImage : () => {},
  sectionInitialValue : {}
}

const BlogPostSectionFields = ({
  formikBag,
  sectionImages,
  setSectionImages,
  tempSectionImage,
  setTempSectionImage,
  sectionInitialValue
}) => (
  <>
    <h2> Sections </h2>
    <p>{ DESCRIPTION.SECTION }</p>


    <FieldArray name={ 'sections' }>
      { ({ remove, push }) => (
        <>
          {
            formikBag.values.sections.map((section, index) => (
              <Card
                key={ `section-field-array${section?.id}` }
                body
              >
                <h3
                  className='font-weight-bolder text-underline'
                >
                  { `Section #${index + 1}` }
                </h3>

                <InputField
                  type='text'
                  label={ `Title ${index + 1}` }
                  placeholder='Retro Chic'
                  name={ `sections[${index}].title` }
                  required={ false }
                />

                <UploadImageField
                  id={ `output-section-image-${index + 1}` }
                  label='Image'
                  required={ false }
                  isMultiple={ true }
                  images={ sectionImages }
                  imageIndex={ index }
                  setImages={ setSectionImages }
                  image={ tempSectionImage }
                  initialImageSrc={ formikBag.values.sections[index].image_url }
                  setValue={ (input) => {
                    setTempSectionImage(input)
                  } }
                />

                <InputField
                  type='textarea'
                  rows='5'
                  label={ `Description ${index + 1}` }
                  name={ `sections[${index}].description` }
                  required={ true }
                />

                <ProductCollectionAsyncMultiselectField
                  name={ `sections[${index}].collection_id` }
                  label='Product Collection'
                  placeholder='Select Collection'
                  isMultiple={ false }
                />

                <Button
                  className='mb-4'
                  color='danger'
                  onClick={ () => remove(index) }
                >
                  { 'Remove Section' }
                </Button>
              </Card>
            ))
          }

          {
            <Button
              color='success'
              className='my-5'
              onClick={ () => push(sectionInitialValue)  }
            >
              { 'Add New Section' }
            </Button>
          }
        </>
      ) }
    </FieldArray>


  </>
)

BlogPostSectionFields.propTypes    = propTypes
BlogPostSectionFields.defaultProps = defaultProps

export default BlogPostSectionFields
